import { defineComponent as _defineComponent } from 'vue'
import BasketSummaryLines from '@/ui/views/checkout/BasketSummaryLines.vue';
import BasketViewModel = Vertica.LouisPoulsen.Application.Commerce.ViewModels.Business.BasketViewModel;
import { store } from '@/store';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketSummaryB2B',
  props: {
    basket: null
  },
  setup(__props: any) {



const hideB2BPrices = computed<boolean>(() => store.getters['hideb2bprices/hideB2BPrices']);
const showRetailPriceWarning = computed<boolean>(() => hideB2BPrices.value);

return { __sfc: true,hideB2BPrices, showRetailPriceWarning, BasketSummaryLines }
}

})